import React from 'react';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import format from 'string-template';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { length } from 'redux-form-validators';

import { PATH } from '../../../constants/path';
import { USERNAME_MAX_LENGTH } from '../../../constants/form';
import { COOKIE_KEY_REDIRECT_AFTER_LOGIN } from '../../../constants/cookie';

import { loginUser } from '../../../services/authentication/login/actions';

import {
    FormComponent,
    LegendFieldComponent,
    TextInputFieldComponent,
    PasswordInputFieldComponent
} from '../../../components/form';
import Captcha from '../../captcha/Captcha';
import LocalizedNavLink from '../../router/LocalizedNavLink';
import { SuccessInfoComponent } from '../../form/SuccessInfoComponent';

import './LoginFormComponent.scss';

class LoginFormComponent extends React.Component {
    submit = data => {
        const { loginUser, currentPath, history } = this.props;

        loginUser(data, () => {
            if (sessionStorage.getItem(COOKIE_KEY_REDIRECT_AFTER_LOGIN)) {
                history.push(sessionStorage.getItem(COOKIE_KEY_REDIRECT_AFTER_LOGIN));
                sessionStorage.removeItem(COOKIE_KEY_REDIRECT_AFTER_LOGIN);
            } else {
                this.props.history.push(currentPath ? currentPath : PATH.HOME_PATH);
            }
        });
    };

    render() {
        const {
            errorMessage,
            requestSubmit,
            successSubmit,
            errorSubmit,
            i18nForm,
            i18nRegister,
            i18nLogin
        } = this.props;

        if (!successSubmit) {
            return (
                <FormComponent
                    form="login-form"
                    onSubmit={this.submit}
                    requestSubmit={requestSubmit}
                    errorSubmit={errorSubmit}
                    initialValues={{}}
                    className="login-form"
                    submitText={i18nRegister.CONNECT_ME}>
                    <TextInputFieldComponent
                        name="username"
                        placeholder={i18nForm.PLACEHOLDER_USERNAME_EMAIL}
                        isRequired
                        validate={[
                            length({
                                max: USERNAME_MAX_LENGTH,
                                msg: format(i18nForm.USERNAME_SIZE_MAX_ERROR, USERNAME_MAX_LENGTH)
                            })
                        ]}
                    />
                    <PasswordInputFieldComponent
                        name="password"
                        placeholder={i18nForm.PLACEHOLDER_PASSWORD}
                        noDefaultValidation
                        isRequired
                    />

                    <Captcha />

                    <LegendFieldComponent classNameInputContainer="small txtright">
                        <LocalizedNavLink
                            to={PATH.FORGOTTEN_PASSWORD_PATH}
                            name="loginModal-toForgotPassword">
                            {i18nForm.PASSWORD_FORGOTTEN}
                        </LocalizedNavLink>
                    </LegendFieldComponent>
                    <React.Fragment>
                        {errorMessage && (
                            <LegendFieldComponent classNameInputContainer="color-err">
                                {errorMessage}
                            </LegendFieldComponent>
                        )}
                    </React.Fragment>
                </FormComponent>
            );
        } else {
            return (
                <SuccessInfoComponent>
                    <p>{i18nLogin.LOGIN_SUCCESS}</p>
                </SuccessInfoComponent>
            );
        }
    }
}

LoginFormComponent.propTypes = {
    currentPath: PropTypes.string.isRequired
};

// Which props do we want to inject, given the global state?
const mapStateToProps = state => {
    return {
        errorMessage: state.authentication.error || '',
        requestSubmit: state.authentication.fetching || false,
        errorSubmit: !isEmpty(state.authentication.error),
        successSubmit: state.authentication.isAuthenticated,
        i18nForm: state.i18n.feature.form,
        i18nRegister: state.i18n.page.REGISTER,
        i18nLogin: state.i18n.page.LOGIN
    };
};

const mapDispatchToProps = {
    loginUser
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginFormComponent));



// WEBPACK FOOTER //
// ./src/components/authentication/login/LoginFormComponent.js